export const myPartiesResponseKeys = {
  party: ["id", "partyDate", "city", "bookingType", "status", "createdAt", "name", "isPublicTableBooking"],
  requestedListings: ["id", "title", "picture", "clubName"],
  promotersOffers: {
    promoter: ["id", "FirstName", "Gender", "Rating"],
    offers: [
      "id",
      "clubName",
      "offerType",
      "minSpend",
      "options",
      "isAccepted",
      "currencySymbol",
    ],
  },
  invitations: [
    "id",
    "firstName",
    "lastName",
    "gender",
    "age",
    "photos",
    "isGroupAdmin",
    "status",
    "fromId",
    "profileType",
    "dateOfBirth",
    "cityId",
    "email",
    "phoneNumber",
  ],
  hostChatMessages: [
    "senderName",
    "timestamp",
    "message",
    "type",
    "lastLogin",
    "fromUserId",
    "toUserId"
  ],
};


export const promoterGroupOpenClubsKeys = {
  openClubs: [
    "ClubId",
    "PictureUrl",
    "DisplayName",
    "IsInHousePromoter",
    "ClubName",
  ]
}

export const openClubListingsKeys = {
  openClubListings: [
    "ListingId",
    "PictureUrl",
    "DisplayName",
    "ClubId",
    "ClubName",
  ]
}

export const userProfileInfoResponseKeys = [
  "Id",
  "FirstName",
  "LastName",
  "DateOfBirth",
  "UserType",
  "Gender",
  "CityId",
  "Email",
  "PhonoNumber",
  "Bio",
  "HomeCity",
  "CountProfilePictures",
  "ProfileType"
]

export const cityResponseKeys = [
  "Id",
  "Name"
]
